import React, { useState } from "react";
import "./HrTeamSection.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  selectSelectedMenu,
  setSelectedMenu,
  setSelectedMenuId,
} from "../../../redux/features/appData";

interface TeamMember {
  id: string;
  name: string;
  avatarURL: string;
  last24Hours: boolean;
}

interface HrTeamSectionProps {
  hrTeamMembers: TeamMember[];
}

const HrTeamSection: React.FC<HrTeamSectionProps> = ({ hrTeamMembers }) => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const visibleMembers = 4; // Show 4 team members at a time
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Function to go to the next set of team members
  const next = (): void => {
    if (currentIndex + visibleMembers < hrTeamMembers.length) {
      setCurrentIndex(currentIndex + visibleMembers);
    }
  };

  // Function to go to the previous set of team members
  const prev = (): void => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - visibleMembers);
    }
  };

  return (
    <div className="hr-team-section">
      <div className="row">
        <div className="hr-team-section-header">HR Team</div>
        <div
          className="hr-team-add-team"
          onClick={() => {
            navigate("/workspaces?tab=3");
            dispatch(setSelectedMenu(null));
            dispatch(setSelectedMenuId(null));
          }}>
          Add Team
        </div>
      </div>
      <div className="carousel-wrapper">
        {currentIndex > 0 && (
          <button className="carousel-arrow left" onClick={prev}>
            <img src="/icons/hr_arrow_back.svg" alt="Left arrow" />
          </button>
        )}
        <div className="hr-team-members">
          {hrTeamMembers
            .slice(currentIndex, currentIndex + visibleMembers)
            .map((member) => (
              <div key={member.id} className="team-member">
                <div className="avatar-wrapper">
                  <img
                    className="team-member-avatar"
                    src={member.avatarURL}
                    alt={`${member.name}'s Avatar`}
                  />
                  {member.last24Hours && <div className="status-badge" />}{" "}
                  <div className="team-member-name">{member.name}</div>
                </div>
              </div>
            ))}
        </div>
        {currentIndex + visibleMembers < hrTeamMembers.length && (
          <button className="carousel-arrow right" onClick={next}>
            <img src="/icons/hr_arrow_forward.svg" alt="Left arrow" />
          </button>
        )}
      </div>
    </div>
  );
};

export default HrTeamSection;
